module.exports = __webpack_public_path__ + "img/mistakesText15.2cee8c94.png";